export const POSITION = {
  x: ['left', 'center', 'right'],
  y: ['top', 'bottom'],
}
